import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'

function PrivacyPolicy() {

     const [pageTitle,setPageTitle] = useState('About Us');
            const [pageContent,setPageContent] = useState('');
          
    
        useEffect(() => {
                getData()
            }, []);
        
            const getData = async () => {
                try {
                    const response = await fetch('https://api.kahaaniplus.com/api/v1/page/privacy-policy');
                    const data = await response.json();
                    setPageTitle(data.data.page_title);
                    setPageContent(data.data.page_content);
                    console.log(data);
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            };
    


    return (
        <Container className='mt-5'>
            <h1 className='text-center'>{pageTitle}</h1>
            <p className='my-para'  dangerouslySetInnerHTML={{ __html: pageContent }}>

             {/*   <b> Effective Date: 14-04-2025</b><br/>

                1. Introduction<br/>

                That TIARA DIGITAL SERVICES PRIVATE LIMITED ("we", "us", or "our") operates the website located at www.kahaaniplus.in (the "Site"), where we offer electronic books ("e-books") for sale and download. We are committed to protecting the privacy of our users ("user", "you", or "your"). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our Site. By accessing the Site, you agree to this Privacy Policy.<br/>

                2. Information We Collect<br/>

                That we collect information that identifies, relates to, describes, references, is capable of being associated with, or could reasonably be linked, directly or indirectly, with a particular consumer or device (“personal information”). In particular, our Site has collected the following categories of personal information from its consumers :<br/>

                - Identifiers: such as a real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email address, account name, or other similar identifiers.<br/>
                - Commercial information: including records of products or services purchased, obtained, or considered, or other purchasing or consuming histories or tendencies.<br/>
                - Internet or other similar network activity: including, but not limited to, browsing history, search history, information on a consumer's interaction with a website, application, or advertisement.<br/>

                3. How We Use Your Information<br/>

                That we use the information we collect or receive:<br/>

                - To fulfill or meet the reason you provided the information. For example, if you share your name and contact information to request a price quote or ask a question about our products, we will use that personal information to respond to your inquiry.<br/>
                - To provide, support, personalize, and develop our Site, products, and services.<br/>
                - To process your requests, purchases, transactions, and payments and prevent transactional fraud.<br/>
                - To personalize your Site experience and to deliver content and product and service offerings relevant to your interests, including targeted offers and ads through our Site, third-party sites, and via email or text message (with your consent, where required by law).<br/>

                4. Sharing Your Personal Information<br/>

                That we never disclose your personal information to a third party for any purpose.<br/>

                5. Your Rights and Choices<br/>

                That you have specific rights regarding your personal information. This section describes your rights as a consumer and explains how to exercise those rights.<br/>

                - Access to Specific Information and Data Portability Rights<br/>
                - Deletion Request Rights<br/>
                - Non-Discrimination<br/>

                6. Security<br/>

                That we implement reasonable security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information.<br/>

                7. Changes to Our Privacy Policy<br/>

                That we reserve the right to amend this privacy policy at our discretion and at any time. When we make changes to this privacy policy, we will post the updated notice on the Site and update the notice's effective date. Your continued use of our Site following the posting of changes constitutes your acceptance of such changes.<br/>

                8. Contact Information<br/>

                If you have any questions or comments about this policy, the ways in which this website collects and uses your information described here, your choices and rights regarding such use, or wish to exercise your rights under California law, please do not hesitate to contact us at: contactus@tiaradigital.in<br/>

                9. Governing Law<br/>

                That this Privacy Policy and any disputes arising under it will be governed by and interpreted in accordance with the laws of INDIA, without reference to its conflict of law principles.
 */}
            </p>
        </Container>


    )
}

export default PrivacyPolicy